
$(function () {
  $('.nav-ol .nav a,.nav-sp .nav a,.nav-sp .nav a,#cnt-footer-nav .nav-box a').each(function () {
    var $href = $(this).attr('href');

    if (location.href.match($href)) {
      $(this).addClass('active');
      $("a.home").removeClass('active');
    } else {
      $(this).removeClass('active');
    }

    var url = location.href;
    if (url == "https://cocolo-gift.jp/") {
      $("a.home").addClass('active');
    }

  });

  $('.nav-ol .nav-li').on('mouseenter',function(){
    // console.log(1)
    $(this).find('.x-nav-child').addClass('active');
  })

  $('.nav-ol .nav-li').on('mouseleave',function(){
      $('.x-nav-child').removeClass('active');
  })

  $('body').on('click','.x-nav-item-add',function(){
    $(this).parent().find('.x-nav-child').toggle();
  })


  // 2018-08-03
  // 点击微信，弹出页面，扫码关注微信公众号
  $('.ie-footer-center .weixin-show').on('click',function(){
    $(this).parent().parent().parent().find('.weixin-popup').addClass('active');
  })

  $('.weixin-popup .weixin-close').on('click',function(){
    $(this).parent().removeClass('active');
  })

  $('.x-header .x-nav .x-nav-item').on('mouseenter',function(){
    $(this).find('.x-nav-child').addClass('active');
  })


  $('.x-header .x-nav .x-nav-item').on('mouseleave',function(){
    $('.x-nav-child').removeClass('active');
  })


  $('.x-sp-menu').on('click', function () {
    $(this).toggleClass('open');
    if ($('.nav-mobile-box').hasClass('show')) {
      $('.nav-mobile-box').removeClass('show');
      setTimeout(function () {
        $('.nav-mobile-box').hide();
      }, 400);
      $('body').css({
        'overflow-y': 'visible'
      });
    } else {
      $('.nav-mobile-box').show();
      setTimeout(function () {
        $('.nav-mobile-box').addClass('show');
      }, 1);
      $('body').css({
        "overflow": "hidden"
      });

    }
  });

  $('.slicknav_item').on('click', function () {
    var item = $(this).parent();
    if (item.find('.x-nav-child').css('display') == 'none') {
      item.find('.x-nav-child').slideDown();
      item.find('.slicknav_arrow').hide();
    } else {
      item.find('.x-nav-child').slideUp();
      item.find('.slicknav_arrow').show();

    }
  });



//end
// 2018-08-03



  $('.sp-menu').click(function () {
    $('nav .nav-sp').fadeIn(0);
    $(this).toggleClass('open');
    $('nav .nav-sp').toggleClass('open');
    if ($('.sp-menu').hasClass('open')) {
      $('body').css({"overflow":"hidden"});
      setTimeout(function () {
        $('nav .nav-sp').removeClass('close');
        $('.show-hide-menu').removeClass('close');
      }, 0);
      $(window).on('touchmove.noScroll', function (e) {
        e.preventDefault();
      });
    } else {
      $('body').css({'overflow-y':'visible'})
      setTimeout(function () {
        $('nav .nav-sp').addClass('close');
        $('nav .nav-sp').fadeOut();

        $('.show-hide-menu').addClass('close');

      }, 0);
      $(window).off('.noScroll');
    }
  });
  $('nav .nav-sp .nav a').click(function () {
    $(window).off('.noScroll');
  });

});






$(function () {

  $(window).scroll(function () {
    $(".js-scroll").each(function () {
      var imgPos = $(this).offset().top;
      var scroll = $(window).scrollTop();
      var windowHeight = $(window).height();
      if (scroll > imgPos - windowHeight + 50) {
        $(this).addClass("js-scroll-in");
      }
    });
  });
  $(window).scroll();

  $(window).scroll(function () {
    $(".js-scroll-blur").each(function () {
      var imgPos = $(this).offset().top;
      var scroll = $(window).scrollTop();
      var windowHeight = $(window).height();
      if (scroll > imgPos - windowHeight + 50) {
        $(this).addClass("js-scroll-blur-in");
      }
    });
  });
});

$(window).scroll(function () {
  $(".effect").each(function () {
    var imgPos = $(this).offset().top;
    var scroll = $(window).scrollTop();
    var windowHeight = $(window).height();
    if (scroll > imgPos - windowHeight + windowHeight / 5 + 50) {
      $(this).addClass("effect-in");
    } else {

      $(this).removeClass("effect-in");
    }
  });
});

// 获取地址栏url参数
(function($){
  $.getUrlParam = function(name) {
    var reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
    var r = window.location.search.substr(1).match(reg);
    if (r!=null) return unescape(r[2]); return null;
  }
})(jQuery);

// 左右布局的选项卡
function tabControl() {
  var allItem = $('.ie-side-nav .ie-side-nav--item');
  // 遍历左边栏，展示相应的产品列表
  allItem.each(function(idx) {
    if($(this).hasClass('active')) {
      $('.side-nav-layout--right').eq(idx).show();
    }

    // 点击切换产品
    $(this).click(function() {
      allItem.removeClass('active').eq(idx).addClass('active');
      $('.side-nav-layout--right').hide().eq(idx).show();
    })
  });
};
